<template>
  <div
    class="text-secondary text-sm leading-4 underline font-bold cursor-pointer"
    @click="openDialog"
  >
    Открыть диалог
  </div>
</template>

<script>
export default {
  name: 'OpenDialogsProButton',
  props: {
    phone: {
      type: String,
      required: true,
    },
  },
  methods: {
    openDialog() {
      window.open(`https://new.dialogs.pro/?crm[dialogIds][0]=${(this.phone || '').replace(/^\+/, '')}@c.us&api[license_id]=46937&api[messenger_type]=grWhatsApp`, '_blank');
    },
  },
};
</script>
